import fancybox from 'fancybox/dist/js/jquery.fancybox.js'
import 'fancybox/dist/css/jquery.fancybox.css';

document.addEventListener('DOMContentLoaded', function(){
	$(".fancybox").fancybox();
})
